import { Socket, io } from 'socket.io-client';
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware'
import { ClientToServerEvents, ServerToClientEvents } from '../interfaces/Socket';
import { RecentChatHistory } from '../interfaces/Chat/RecentChatHistory';
import { ImageBlob } from '../interfaces/Chat/ImageBlob';
import { VideoBlob } from '../interfaces/Chat/VideoBlob';
import { FileBlob } from '../interfaces/Chat/FileBlob';
import { MediaDownload } from '../interfaces/Chat/MediaDownload';
import { RawMessage } from '../interfaces/Chat/RawMessage';
import { PersistedMessage } from '../interfaces/Chat/PersistedMessage';
import storage from '../db';
import { LabelChatProps } from '../interfaces/Chat/LabelChat';
import { ChatGroupWindowData, ChatWindowData } from '../interfaces/Chat/ChatWindowData';
import { QuickReply } from '../interfaces/Chat/QuickReply';
import { IForwardChatPayload } from '../interfaces/Chat/ForwardChat';
import { ListChatPhone } from '../interfaces/Chat/ListChatPhone';
import { ContactChatProps } from '../interfaces/Chat/ContactChat';
import { ChatGroupMessage, ChatMessage, ChatPipeline, GroupMessageNotifications, ListChatAgent, ListChatGroupMessage, ListChatGroupParticipants, ListChatGroupRoom, ListChatMessage, ListChatRoom, MessageNotifications } from '../interfaces/Chat/Chat';
import { Pipeline } from '../interfaces';
import { subDays } from 'date-fns';

const API_URL = process.env.REACT_APP_API_URL

type ChatState = {
    mode: '' | 'normal' | 'search' | 'sync-room',
    setMode: (mode: '' | 'normal' | 'search' | 'sync-room') => void
    groupMode: '' | 'normal' | 'search' | 'sync-room',
    setGroupMode: (groupMode: '' | 'normal' | 'search' | 'sync-room') => void
    isSyncRoom: boolean,
    setIsSyncRoom: (updater: (isSyncRoom: boolean) => boolean) => void
    isGroupSyncRoom: boolean,
    setIsGroupSyncRoom: (updater: (isGroupSyncRoom: boolean) => boolean) => void
    tokenChat: string,
    setTokenChat: (updater: (tokenChat: string) => string) => void;
    isSyncing: boolean,
    setIsSyncing: (updater: (isSyncing: boolean) => boolean) => void;
    isGroupSyncing: boolean,
    setIsGroupSyncing: (updater: (isGroupSyncing: boolean) => boolean) => void;
    selectedChatPhone: ListChatPhone[],
    setSelectedChatPhone: (updater: (selectedChatPhone: ListChatPhone[]) => ListChatPhone[]) => void;
    listChatPhone: ListChatPhone[],
    setListChatPhone: (listChatPhone: ListChatPhone[]) => void
    isOpenCheckBoxForward: boolean,
    setIsOpenCheckBoxForward: (isOpenCheckBoxForward: boolean) => void
    isOpenCheckBoxGroupForward: boolean,
    setIsOpenCheckBoxGroupForward: (isOpenCheckBoxGroupForward: boolean) => void
    isOpenForwardChat: boolean
    setIsOpenForwardChat: (isOpenForwardChat: boolean) => void
    isWaitingForNetwork: boolean
    setIsWaitingForNetwork: (isWaitingForNetwork: boolean) => void
    attachmentMessageId: string
    setAttachmentMessageId: (attachmentMessageId: string) => void
    attachmentUrl: string
    setAttachmentUrl: (attachmentUrl: string) => void
    scrollToId: string
    setScrollToId: (scrollToId: string) => void
    lastSynced: string
    setLastSynced: (lastSynced: string) => void
    agreedTNC: string
    setAgreedTNC: (agreedTNC: string) => void
    connected: boolean
    setConnected: (updater: (connected: boolean) => boolean) => void;
    phoneNumber: string
    setPhoneNumber: (phoneNumber: string) => void
    groupID: string
    setGroupID: (groupID: string) => void
    message: string
    setMessage: (message: string) => void
    groupMessage: string
    setGroupMessage: (groupMessage: string) => void
    listFilterChat: ListChatRoom
    setListFilterChat: (listFilterChat: ListChatRoom) => void
    listFilterChatGroup: ListChatGroupRoom
    setListFilterChatGroup: (listFilterChatGroup: ListChatGroupRoom) => void
    listChatRooms: ListChatRoom
    setListChatRooms: (updater: (listChatRooms: ListChatRoom) => ListChatRoom) => void;
    listChatMessages: ListChatMessage
    setListChatMessages: (updater: (listChatMessages: ListChatMessage) => ListChatMessage) => void;
    listChatGroupRooms: ListChatGroupRoom
    setListChatGroupRooms: (updater: (listChatGroupRooms: ListChatGroupRoom) => ListChatGroupRoom) => void;
    listChatGroupMessages: ListChatGroupMessage
    setListChatGroupMessages: (updater: (listChatGroupMessages: ListChatGroupMessage) => ListChatGroupMessage) => void;
    listChatGroupParticipants: ListChatGroupParticipants
    setListChatGroupParticipants: (updater: (listChatGroupParticipants: ListChatGroupParticipants) => ListChatGroupParticipants) => void;
    editMessage: string
    setEditMessage: (editMessage: string) => void
    editGroupMessage: string
    setEditGroupMessage: (editGroupMessage: string) => void
    replyMessage: ChatMessage | ChatGroupMessage | undefined
    setReplyMessage: (replyMessage: ChatMessage | ChatGroupMessage | undefined) => void
    replyGroupMessage: ChatGroupMessage | undefined
    setReplyGroupMessage: (replyGroupMessage: ChatGroupMessage | undefined) => void
    chatSelectedPipeline: ChatPipeline
    setChatSelectedPipeline: (chatSelectedPipeline: ChatPipeline) => void
    messageNotifications: MessageNotifications
    setMessageNotifications: (updater: (messageNotifications: MessageNotifications) => MessageNotifications) => void;
    groupMessageNotifications: GroupMessageNotifications
    setGroupMessageNotifications: (updater: (groupMessageNotifications: GroupMessageNotifications) => GroupMessageNotifications) => void;
    socket: Socket<ServerToClientEvents, ClientToServerEvents>
    setSocket: (updater: (socket: Socket<ServerToClientEvents, ClientToServerEvents>) => Socket<ServerToClientEvents, ClientToServerEvents>) => void
    messages: ChatMessage[]
    setMessages: (updater: (messages: ChatMessage[]) => ChatMessage[]) => void
    groupMessages: ChatGroupMessage[]
    setGroupMessages: (updater: (groupMessages: ChatGroupMessage[]) => ChatGroupMessage[]) => void
    showChat: boolean
    setShowChat: (showChat: boolean) => void
    showChatGroup: boolean
    setShowChatGroup: (showChatGroup: boolean) => void
    imageBlobUrls: ImageBlob,
    setImageBlobUrls: (imageBlobUrls: ImageBlob) => void
    videoBlobUrls: VideoBlob,
    setVideoBlobUrls: (videoBlobUrls: VideoBlob) => void
    fileBlobUrls: FileBlob,
    setFileBlobUrls: (FileBlobUrls: FileBlob) => void
    mediaDownloads: MediaDownload
    setMediaDownloads: (updater: (mediaDownloads: MediaDownload) => MediaDownload) => void
    menuActive: string
    setMenuActive: (menuActive: string) => void
    windowActive: string
    setWindowActive: (windowActive: string) => void
    chatContacts: ContactChatProps[]
    setChatContacts: (chatLabels: ContactChatProps[]) => void
    chatLabels: LabelChatProps[]
    setChatLabels: (chatLabels: LabelChatProps[]) => void
    selectChatLabel: LabelChatProps
    setSelectChatLabel: (selectChatLabel: LabelChatProps) => void
    selectChatWindow: ChatWindowData[]
    setSelectChatWindow: (selectChatWindow: ChatWindowData[]) => void
    selectChatGroupWindow: ChatGroupWindowData[]
    setSelectChatGroupWindow: (selectChatGroupWindow: ChatGroupWindowData[]) => void
    quickReplies: QuickReply[]
    setQuickReplies: (quickReplies: QuickReply[]) => void
    originalChatPhone: string
    setOriginalChatPhone: (originalChatPhone: string) => void
    isOpenDetailContact: boolean
    setIsOpenDetailContact: (isOpenDetailContact: boolean) => void
    isOpenDetailGroupContact: boolean
    setIsOpenDetailGroupContact: (isOpenDetailGroupContact: boolean) => void
    selectedForwardMessages: ChatMessage[]
    setSelectedForwardMessages: (selectedForwardMessages: ChatMessage[]) => void
    currentMessageForward: ChatMessage | null
    setCurrentMessageForward: (currentMessageForward: ChatMessage | null) => void
    selectedForwardGroupMessages: ChatGroupMessage[]
    setSelectedForwardGroupMessages: (selectedForwardGroupMessages: ChatGroupMessage[]) => void
    currentGroupMessageForward: ChatGroupMessage | null
    setCurrentGroupMessageForward: (currentGroupMessageForward: ChatGroupMessage | null) => void
    selectedChatsForward: string[]
    setSelectedChatsForward: (selectedChatsForward: string[]) => void
    selectedChatGroupsForward: string[]
    setSelectedChatGroupsForward: (selectedChatGroupsForward: string[]) => void
    forwardChatPayload: IForwardChatPayload
    setForwardChatPayload: (forwardChatPayload: IForwardChatPayload) => void
    forwardChatGroupPayload: IForwardChatPayload
    setForwardChatGroupPayload: (forwardChatGroupPayload: IForwardChatPayload) => void
    searchSidebar: string
    setSearchSidebar: (searchSidebar: string) => void
    searchGroupSidebar: string
    setSearchGroupSidebar: (searchGroupSidebar: string) => void
    isFilterSidebar: boolean
    setIsFilterSidebar: (isFilterSidebar: boolean) => void
    isGroupFilterSidebar: boolean
    setIsGroupFilterSidebar: (isGroupFilterSidebar: boolean) => void
    listChatAgents: ListChatAgent
    setListChatAgents: (updater: (listChatAgents: ListChatAgent) => ListChatAgent) => void;
    startDateSession: Date,
    setStartDateSession: (startDateSession: Date) => void,
    endDateSession: Date,
    setEndDateSession: (endDateSession: Date) => void,
    selectMessage: ChatMessage,
    setSelectMessage: (selectMessage: ChatMessage) => void,
    showModalUpdateMessage: boolean,
    setShowModalUpdateMessage: (showModalUpdateMessage: boolean) => void,
    selectGroupMessage: ChatGroupMessage,
    setSelectGroupMessage: (selectGroupMessage: ChatGroupMessage) => void,
    showModalUpdateGroupMessage: boolean,
    setShowModalUpdateGroupMessage: (showModalUpdateGroupMessage: boolean) => void,
}

const tokenChat = await storage.getItem('tokenChat') || '';
const selectedChatPhone = await storage.getItem('selectedChatPhone') || [] as any;
const lastSynced = await storage.getItem('lastSynced') || '';
const connected = await storage.getItem('connected') ? true : false;
const listChatRooms = await storage.getItem('listChatRooms') || {} as any;
const listChatMessages = await storage.getItem('listChatMessages') || {} as any;
const listChatGroupRooms = await storage.getItem('listChatGroupRooms') || {} as any;
const listChatGroupMessages = await storage.getItem('listChatGroupMessages') || {} as any;
const listChatGroupParticipants = await storage.getItem('listChatGroupParticipants') || {} as any;
const listChatAgents = await storage.getItem('listChatAgents') || {} as any;
const messageNotifications = await storage.getItem('messageNotifications') || {} as any;
const groupMessageNotifications = await storage.getItem('groupMessageNotifications') || {} as any;
const mediaDownloads = await storage.getItem('mediaDownloads') || {};

export const useChatStore = create<ChatState>()(
    persist(
        (set) => ({
            mode: '',
            setMode: (mode: '' | 'normal' | 'search' | 'sync-room') => { set({ mode }) },
            groupMode: '',
            setGroupMode: (groupMode: '' | 'normal' | 'search' | 'sync-room') => { set({ groupMode }) },
            isSyncRoom: false,
            setIsSyncRoom: (updater) => set((state) => ({ isSyncRoom: updater(state.isSyncRoom) })),
            isGroupSyncRoom: false,
            setIsGroupSyncRoom: (updater) => set((state) => ({ isGroupSyncRoom: updater(state.isGroupSyncRoom) })),
            tokenChat,
            setTokenChat: (updater) =>
                set((state) => {
                    const updateTokenChat = updater(state.tokenChat);
                    storage.setItem('tokenChat', updateTokenChat as any);
                    return { tokenChat: updateTokenChat };
                }),
            isSyncing: true,
            setIsSyncing: (updater) =>
                set((state) => {
                    const updateIsSyncing = updater(state.isSyncing);
                    storage.setItem('isSyncing', updateIsSyncing as any);
                    return { isSyncing: updateIsSyncing };
                }),
            isGroupSyncing: true,
            setIsGroupSyncing: (updater) =>
                set((state) => {
                    const updateIsSyncing = updater(state.isGroupSyncing);
                    storage.setItem('isGroupSyncing', updateIsSyncing as any);
                    return { isGroupSyncing: updateIsSyncing };
                }),
            selectedChatPhone,
            setSelectedChatPhone: (updater) =>
                set((state) => {
                    const updateSelectedChatPhone = updater(state.selectedChatPhone);
                    storage.setItem('selectedChatPhone', updateSelectedChatPhone as any);
                    return { selectedChatPhone: updateSelectedChatPhone };
                }),
            listChatPhone: [] as ListChatPhone[],
            setListChatPhone: (listChatPhone: ListChatPhone[]) => { set({ listChatPhone }) },
            forwardChatPayload: {} as IForwardChatPayload,
            setForwardChatPayload: (forwardChatPayload: IForwardChatPayload) => { set({ forwardChatPayload }) },
            forwardChatGroupPayload: {} as IForwardChatPayload,
            setForwardChatGroupPayload: (forwardChatGroupPayload: IForwardChatPayload) => { set({ forwardChatGroupPayload }) },
            selectedChatsForward: [],
            setSelectedChatsForward: (selectedChatsForward: string[]) => { set({ selectedChatsForward }) },
            selectedChatGroupsForward: [],
            setSelectedChatGroupsForward: (selectedChatGroupsForward: string[]) => { set({ selectedChatGroupsForward }) },
            currentMessageForward: null,
            setCurrentMessageForward: (currentMessageForward: ChatMessage | null) => { set({ currentMessageForward }) },
            selectedForwardMessages: [] as ChatMessage[],
            setSelectedForwardMessages: (selectedForwardMessages: ChatMessage[]) => { set({ selectedForwardMessages }) },
            currentGroupMessageForward: null,
            setCurrentGroupMessageForward: (currentGroupMessageForward: ChatGroupMessage | null) => { set({ currentGroupMessageForward }) },
            selectedForwardGroupMessages: [] as ChatGroupMessage[],
            setSelectedForwardGroupMessages: (selectedForwardGroupMessages: ChatGroupMessage[]) => { set({ selectedForwardGroupMessages }) },
            isOpenCheckBoxForward: false,
            setIsOpenCheckBoxForward: (isOpenCheckBoxForward: boolean) => { set({ isOpenCheckBoxForward }) },
            isOpenCheckBoxGroupForward: false,
            setIsOpenCheckBoxGroupForward: (isOpenCheckBoxGroupForward: boolean) => { set({ isOpenCheckBoxGroupForward }) },
            isOpenForwardChat: false,
            setIsOpenForwardChat: (isOpenForwardChat: boolean) => { set({ isOpenForwardChat }) },
            originalChatPhone: '',
            setOriginalChatPhone: (originalChatPhone: string) => { set({ originalChatPhone }) },
            isWaitingForNetwork: false,
            setIsWaitingForNetwork: (isWaitingForNetwork: boolean) => { set({ isWaitingForNetwork }) },
            attachmentMessageId: '',
            setAttachmentMessageId: (attachmentMessageId: string) => { set({ attachmentMessageId }) },
            attachmentUrl: '',
            setAttachmentUrl: (attachmentUrl: string) => { set({ attachmentUrl }) },
            scrollToId: '',
            setScrollToId: (scrollToId: string) => { set({ scrollToId }) },
            lastSynced,
            setLastSynced: (lastSynced: string) => { set({ lastSynced }); storage.setItem('lastSynced', lastSynced) },
            agreedTNC: '',
            setAgreedTNC: (agreedTNC: string) => { set({ agreedTNC }) },
            connected,
            setConnected: (updater) =>
                set((state) => {
                    const updateConnected = updater(state.connected);
                    storage.setItem('connected', updateConnected as any);
                    return { connected: updateConnected };
                }),
            phoneNumber: '',
            setPhoneNumber: (phoneNumber: string) => { set({ phoneNumber }) },
            groupID: '',
            setGroupID: (groupID: string) => { set({ groupID }) },
            message: '',
            setMessage: (message: string) => { set({ message }) },
            groupMessage: '',
            setGroupMessage: (groupMessage: string) => { set({ groupMessage }) },
            listFilterChat: {} as ListChatRoom,
            setListFilterChat: (listFilterChat: ListChatRoom) => { set({ listFilterChat }) },
            listFilterChatGroup: {} as ListChatGroupRoom,
            setListFilterChatGroup: (listFilterChatGroup: ListChatGroupRoom) => { set({ listFilterChatGroup }) },
            listChatRooms,
            setListChatRooms: (updater) =>
                set((state) => {
                    const updateChatRooms = updater(state.listChatRooms);
                    storage.setItem('listChatRooms', updateChatRooms as any);
                    return { listChatRooms: updateChatRooms };
                }),
            listChatGroupRooms,
            setListChatGroupRooms: (updater) =>
                set((state) => {
                    const updateChatGroupRooms = updater(state.listChatGroupRooms);
                    storage.setItem('listChatGroupRooms', updateChatGroupRooms as any);
                    return { listChatGroupRooms: updateChatGroupRooms };
                }),
            listChatMessages,
            setListChatMessages: (updater) =>
                set((state) => {
                    const updateListChatMessages = updater(state.listChatMessages);
                    storage.setItem('listChatMessages', updateListChatMessages as any);
                    return { listChatMessages: updateListChatMessages };
                }),
            listChatGroupMessages,
            setListChatGroupMessages: (updater) =>
                set((state) => {
                    const updateListChatGroupMessages = updater(state.listChatGroupMessages);
                    storage.setItem('listChatGroupMessages', updateListChatGroupMessages as any);
                    return { listChatGroupMessages: updateListChatGroupMessages };
                }),
            listChatGroupParticipants,
            setListChatGroupParticipants: (updater) =>
                set((state) => {
                    const updateListChatGroupParticipants = updater(state.listChatGroupParticipants);
                    storage.setItem('listChatGroupParticipants', updateListChatGroupParticipants as any);
                    return { listChatGroupParticipants: updateListChatGroupParticipants };
                }),
            listChatAgents,
            setListChatAgents: (updater) =>
                set((state) => {
                    const updateListChatAgents = updater(state.listChatAgents);
                    storage.setItem('listChatAgents', updateListChatAgents as any);
                    return { listChatAgents: updateListChatAgents };
                }),
            editMessage: '',
            setEditMessage: (editMessage: string) => { set({ editMessage }) },
            editGroupMessage: '',
            setEditGroupMessage: (editGroupMessage: string) => { set({ editGroupMessage }) },
            replyMessage: undefined,
            setReplyMessage: (replyMessage: ChatMessage | ChatGroupMessage | undefined) => { set({ replyMessage }) },
            replyGroupMessage: undefined,
            setReplyGroupMessage: (replyGroupMessage: ChatGroupMessage | undefined) => { set({ replyGroupMessage }) },
            chatSelectedPipeline: {} as ChatPipeline,
            setChatSelectedPipeline: (chatSelectedPipeline: ChatPipeline) => { set({ chatSelectedPipeline }) },
            messageNotifications,
            setMessageNotifications: (updater) =>
                set((state) => {
                    const updateIncomingMessageNotifications = updater(state.messageNotifications);
                    storage.setItem('messageNotifications', updateIncomingMessageNotifications as any);
                    return { messageNotifications: updateIncomingMessageNotifications };
                }),
            groupMessageNotifications,
            setGroupMessageNotifications: (updater) =>
                set((state) => {
                    const updateIncomingGroupMessageNotifications = updater(state.groupMessageNotifications);
                    storage.setItem('groupMessageNotifications', updateIncomingGroupMessageNotifications as any);
                    return { groupMessageNotifications: updateIncomingGroupMessageNotifications };
                }),
            socket: io(`${API_URL}whatsapp-chat`),
            setSocket: (updater) => set((state) => ({ socket: updater(state.socket) })),
            messages: [],
            setMessages: (updater) => set((state) => ({ messages: updater(state.messages) })),
            groupMessages: [],
            setGroupMessages: (updater) => set((state) => ({ groupMessages: updater(state.groupMessages) })),
            showChat: false,
            setShowChat: (showChat: boolean) => { set({ showChat }) },
            showChatGroup: false,
            setShowChatGroup: (showChatGroup: boolean) => { set({ showChatGroup }) },
            imageBlobUrls: {},
            setImageBlobUrls: (imageBlobUrls: ImageBlob) => { set({ imageBlobUrls }) },
            videoBlobUrls: {},
            setVideoBlobUrls: (videoBlobUrls: VideoBlob) => { set({ videoBlobUrls }) },
            fileBlobUrls: {},
            setFileBlobUrls: (fileBlobUrls: FileBlob) => { set({ fileBlobUrls }) },
            mediaDownloads,
            setMediaDownloads: (updater) =>
                set((state) => {
                    const updatedMediaDownloads = updater(state.mediaDownloads);
                    storage.setItem('mediaDownloads', updatedMediaDownloads as any);
                    return { mediaDownloads: updatedMediaDownloads };
                }),
            menuActive: 'chat',
            setMenuActive: (menuActive: string) => { set({ menuActive }) },
            windowActive: 'chat',
            setWindowActive: (windowActive: string) => { set({ windowActive }) },
            chatContacts: [],
            setChatContacts: (chatContacts: ContactChatProps[]) => { set({ chatContacts }) },
            chatLabels: [],
            setChatLabels: (chatLabels: LabelChatProps[]) => { set({ chatLabels }) },
            selectChatLabel: {} as LabelChatProps,
            setSelectChatLabel: (selectChatLabel: LabelChatProps) => { set({ selectChatLabel }) },
            selectChatWindow: [],
            setSelectChatWindow: (selectChatWindow: ChatWindowData[]) => { set({ selectChatWindow }) },
            selectChatGroupWindow: [],
            setSelectChatGroupWindow: (selectChatGroupWindow: ChatGroupWindowData[]) => { set({ selectChatGroupWindow }) },
            quickReplies: [],
            setQuickReplies: (quickReplies: QuickReply[]) => { set({ quickReplies }) },
            isOpenDetailContact: false,
            setIsOpenDetailContact: (isOpenDetailContact: boolean) => { set({ isOpenDetailContact }) },
            isOpenDetailGroupContact: false,
            setIsOpenDetailGroupContact: (isOpenDetailGroupContact: boolean) => { set({ isOpenDetailGroupContact }) },
            searchSidebar: '',
            setSearchSidebar: (searchSidebar: string) => { set({ searchSidebar }) },
            searchGroupSidebar: '',
            setSearchGroupSidebar: (searchGroupSidebar: string) => { set({ searchGroupSidebar }) },
            isFilterSidebar: false,
            setIsFilterSidebar: (isFilterSidebar: boolean) => { set({ isFilterSidebar }) },
            isGroupFilterSidebar: false,
            setIsGroupFilterSidebar: (isGroupFilterSidebar: boolean) => { set({ isGroupFilterSidebar }) },
            startDateSession: subDays(new Date, 29),
            setStartDateSession: (startDateSession: Date) => { set({ startDateSession }) },
            endDateSession: new Date,
            setEndDateSession: (endDateSession: Date) => { set({ endDateSession }) },
            selectMessage: {} as ChatMessage,
            setSelectMessage: (selectMessage: ChatMessage) => { set({ selectMessage }) },
            showModalUpdateMessage: false,
            setShowModalUpdateMessage: (showModalUpdateMessage: boolean) => { set({ showModalUpdateMessage }) },
            selectGroupMessage: {} as ChatGroupMessage,
            setSelectGroupMessage: (selectGroupMessage: ChatGroupMessage) => { set({ selectGroupMessage }) },
            showModalUpdateGroupMessage: false,
            setShowModalUpdateGroupMessage: (showModalUpdateGroupMessage: boolean) => { set({ showModalUpdateGroupMessage }) },
        }),
        {
            partialize: (state) => ({
                // recentChatHistories: state.recentChatHistories,
            }),
            name: 'recent-chat-storage',
            storage: createJSONStorage(() => storage),
        },
    )
);
